module.exports = __webpack_public_path__ + "img/club-logo.09af8179.png";